<script lang="ts">
  interface Props {
    total: number;
    page: number;
    pageSize: number;
    /// 送れるページの上限。API 側に走査範囲の制限があり、total から計算した最終ページまで
    /// 辿れない一覧のために置く (会員一覧 = Auth0 の先頭 1000 件)。未指定なら total 任せ。
    maxPage?: number;
    onChange: (page: number) => void;
  }

  let { total, page, pageSize, maxPage, onChange }: Props = $props();

  let lastPage = $derived(
    Math.min(Math.max(1, Math.ceil(total / pageSize)), maxPage ?? Number.POSITIVE_INFINITY),
  );
  let hasPrev = $derived(page > 1);
  let hasNext = $derived(page < lastPage);
  let fromIdx = $derived(total === 0 ? 0 : (page - 1) * pageSize + 1);
  let toIdx = $derived(Math.min(page * pageSize, total));

  function go(delta: number): void {
    const next = Math.min(Math.max(1, page + delta), lastPage);
    if (next !== page) onChange(next);
  }
</script>

<div class="pagination" aria-label="ページネーション">
  <div class="muted">
    {total} 件中 {fromIdx}-{toIdx}
  </div>
  <div class="controls">
    {#if hasPrev}
      <button type="button" class="btn" onclick={() => go(-1)}>前へ</button>
    {:else}
      <span class="btn disabled">前へ</span>
    {/if}
    <span class="page-info">{page} / {lastPage}</span>
    {#if hasNext}
      <button type="button" class="btn" onclick={() => go(1)}>次へ</button>
    {:else}
      <span class="btn disabled">次へ</span>
    {/if}
  </div>
</div>

<style>
  .pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    font-size: 12px;
  }
  .muted {
    color: var(--muted, #6b7280);
  }
  .controls {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .btn {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border: 1px solid var(--border, #e3e6eb);
    border-radius: var(--radius, 6px);
    background: var(--panel, #ffffff);
    color: var(--text, #1a1c1f);
    font: inherit;
    line-height: 1.4;
    cursor: pointer;
    text-decoration: none;
  }
  button.btn:hover {
    background: #f3f4f6;
  }
  .btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .page-info {
    color: var(--muted, #6b7280);
  }
</style>
